// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/clock-10.js';

import { paths } from '../generated/clock-10';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('clock-10', Original, paths);
